import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=4cc646b4&scoped=true&"
import script from "./LocationForm.vue?vue&type=script&lang=ts&"
export * from "./LocationForm.vue?vue&type=script&lang=ts&"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=4cc646b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc646b4",
  null
  
)

export default component.exports